import {Cost} from "./cost";
import {FormulaCostItem} from "./formula-cost-item";

export class FormulaCost extends Cost {

  public formulaCostItems: FormulaCostItem[] = [];
  public jsonLogicFormula: string; // json logic
  public meta: any;

}
